import React from 'react';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { MdOutlineTextsms } from "react-icons/md";
import { TfiEmail } from "react-icons/tfi";
import { SiWhatsapp } from "react-icons/si";

class AutomationAction extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      smsVendor: 0, modelSms: false, modelSmsTmp: 0, staffSms: false,
      staffSmsTmp: 0,
      emailVendor: { value: 0 }, modelEmail: false, modelEmailTmp: 0, staffEmail: false,
      staffEmailTmp: 0,
      reportSms: false, reportSmsTmp: 0, reportEmail: false, reportEmailTmp: 0,
      staffNotify: false, reportNotify: false, ...props.value
    };

    this.smsVendor = props.mainModel.sms_config.options;
    this.emailVendor = props.mainModel.email_config.options;

    this.smsTmp = props.mainModel.sms_temp.options;
    this.emailTmp = props.mainModel.email_temp.options;
    this.whatsAppTmp = props.mainModel.whatsapp_temp.options;
  }

  onChange = (field, val) => {
    const state = { ...this.state };
    state[field] = val;
    this.props.onChange(field, val);
    this.setState({ ...state });
  }
  onTmp = (field, selected) => this.onChange(field, selected !== null ? selected : 0);

  render() {
    return (
      <div className="col-md-12">
        <div className="col">
          <div className="form-group">
            <h5><MdOutlineTextsms /> SMS</h5>
            <div className="row">
              <div className="col">
                <Form.Check>
                  <Form.Check.Label>
                    SMS Vendor
                    <Select value={this.state.smsVendor} options={this.smsVendor} isClearable={true}
                      onChange={opt => this.onTmp('smsVendor', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.modelSms}
                    onChange={event => this.onChange('modelSms', event.target.checked)} />
                  <Form.Check.Label>
                    Send SMS to Lead / Contact, Select Template
                    <Select value={this.state.modelSmsTmp} options={this.smsTmp}
                      isClearable={true} isDisabled={!this.state.modelSms}
                      onChange={opt => this.onTmp('modelSmsTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.staffSms}
                    onChange={event => this.onChange('staffSms', event.target.checked)} />
                  <Form.Check.Label>
                    Send SMS to Sales Person, Select Template
                    <Select value={this.state.staffSmsTmp} options={this.smsTmp}
                      isClearable={true} isDisabled={!this.state.staffSms}
                      onChange={opt => this.onTmp('staffSmsTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.reportSms}
                    onChange={event => this.onChange('reportSms', event.target.checked)} />
                  <Form.Check.Label>
                    Send SMS to Reporting Sales Person, Select Template
                    <Select value={this.state.reportSmsTmp} options={this.smsTmp}
                      isClearable={true} isDisabled={!this.state.reportSms}
                      onChange={opt => this.onTmp('reportSmsTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
            </div>
          </div>

          <div className="form-group">
            <h5><TfiEmail /> Email</h5>

            <div className="row">
              <div className="col">
                <Form.Check>
                  <Form.Check.Label>
                    Email Vendor
                    <Select value={this.state.emailVendor} options={this.emailVendor} isClearable={true}
                      onChange={opt => this.onTmp('emailVendor', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.modelEmail}
                    onChange={event => this.onChange('modelEmail', event.target.checked)} />
                  <Form.Check.Label>
                    Send Email to Lead / Contact, Select Template
                    <Select value={this.state.modelEmailTmp} options={this.emailTmp}
                      isClearable={true} isDisabled={!this.state.modelEmail}
                      onChange={opt => this.onTmp('modelEmailTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.staffEmail}
                    onChange={event => this.onChange('staffEmail', event.target.checked)} />
                  <Form.Check.Label>
                    Send Email to Sales Person, Select Template
                    <Select value={this.state.staffEmailTmp} options={this.emailTmp}
                      isClearable={true} isDisabled={!this.state.staffEmail}
                      onChange={opt => this.onTmp('staffEmailTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.reportEmail}
                    onChange={event => this.onChange('reportEmail', event.target.checked)} />
                  <Form.Check.Label>
                    Send Email to Reporting Sales Person, Select Template
                    <Select value={this.state.reportEmailTmp} options={this.emailTmp}
                      isClearable={true} isDisabled={!this.state.reportEmail}
                      onChange={opt => this.onTmp('reportEmailTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
            </div>
          </div>

          <div className="form-group">
            <h5><SiWhatsapp /> WhatsApp</h5>

            <div className="row">
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.modelWhatsApp}
                    onChange={event => this.onChange('modelWhatsApp', event.target.checked)} />
                  <Form.Check.Label>
                    Send WhatsApp to Lead / Contact, Select Template
                    <Select value={this.state.modelWhatsAppTmp} options={this.whatsAppTmp}
                      isClearable={true} isDisabled={!this.state.modelWhatsApp}
                      onChange={opt => this.onTmp('modelWhatsAppTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
              <div className="col">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.staffWhatsApp}
                    onChange={event => this.onChange('staffWhatsApp', event.target.checked)} />
                  <Form.Check.Label>
                    Send WhatsApp to Sales Person, Select Template
                    <Select value={this.state.staffWhatsAppTmp} options={this.whatsAppTmp}
                      isClearable={true} isDisabled={!this.state.staffWhatsApp}
                      onChange={opt => this.onTmp('staffWhatsAppTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Form.Check>
                  <Form.Check.Input type="checkbox" checked={this.state.reportWhatsApp}
                    onChange={event => this.onChange('reportWhatsApp', event.target.checked)} />
                  <Form.Check.Label>
                    Send WhatsApp to Reporting Sales Person, Select Template
                    <Select value={this.state.reportWhatsAppTmp} options={this.whatsAppTmp}
                      isClearable={true} isDisabled={!this.state.reportWhatsApp}
                      onChange={opt => this.onTmp('reportWhatsAppTmp', opt)} />
                  </Form.Check.Label>
                </Form.Check>
              </div>
            </div>
          </div>
        </div>

        <div className="formhead col-md-12 p-0"><h4>Mobile / Desktop Notification</h4></div>
        <div className="col-md-12">
          <div className="form-group">
            <Form.Check>
              <Form.Check.Input type="checkbox" checked={this.state.staffNotify}
                onChange={event => this.onChange('staffNotify', event.target.checked)} />
              <Form.Check.Label> Send Notification to Sales Person </Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input type="checkbox" checked={this.state.reportNotify}
                onChange={event => this.onChange('reportNotify', event.target.checked)} />
              <Form.Check.Label> Send Notification to Reporting Sales Person </Form.Check.Label>
            </Form.Check>
          </div>
        </div>
      </div >
    );
  }
}
export default AutomationAction;
